<template>
  <div>
    <!--  Day Content -->
    <tippy arrow theme="light-border" trigger="click" animateFill="false" interactive>
      <template v-slot:trigger>
        <div class="c-calendar__card-content">
          <div class="c-calendar__project-info">
            <span class="c-calendar__company">
              <strong
                v-if="first_entry.project !== null"
              >{{ first_entry.project.customer.company_name}}</strong>
              <strong v-if="first_entry.tour !== null">{{ first_entry.tour.tour_number }}</strong>
            </span>
            <template v-if="first_entry.project !== null">
              <span
                class="c-calendar__address"
                v-if="first_entry.project.address.city"
              >{{ first_entry.project.address.city}}</span>
            </template>

            <span class="c-calendar__comment" v-if="comment">
              <strong>{{ comment }}</strong>
            </span>
             <span
              class="c-calendar__meta-color is-active"
            ></span>
            <span
              class="c-calendar__meta-color is-fixed"
              v-if="isFixed"
            ></span>
            <span
              class="c-calendar__meta-color is-holiday"
              v-if="is_holiday"
            ></span>
            <div class="c-calendar__count">
              <span class="c-calendar__count-text">
                {{ count }}
                <template v-if="count > 1">{{ $t('weeks.entries') }}</template>
                <template v-else>{{ $t('weeks.entry') }}</template>
              </span>
            </div>
          </div>
        </div>
      </template>
      <!--  Tooltip Content -->
      <section class="c-calendar__tooltip">
        <header class="grid-x grid-margin-x align-justify align-middle">
          <div class="cell auto">
            <strong>
              <template v-if="count > 1">{{ $t('weeks.entries') }}</template>
              <template v-else>{{ $t('weeks.entry') }}</template>
              ({{ count }})
            </strong>
          </div>
          <div class="cell small-4">
            <div class="c-calendar__tooltip-edit-button">
              <router-link
                :to="{ name : 'update-day', params: {daily_entries: this.daily_entries, date: this.$moment(this.date).format('YYYY-MM-DD'), kolonne: this.kolonne_number} }"
                class="c-calendar__tooltip-edit-button-link button button--action button--action--edit"
                :title="$t('update')"
              >
                <span class="show-for-sr">{{ $t('update') }}</span>
              </router-link>
            </div>
          </div>
        </header>
        <div class="grid-x grid-margin-x">
          <div class="cell small-12">
            <div class="c-calendar__tooltip-project-numbers">
              <section v-for="(entry, index) in daily_entries" :key="index">
                <template v-if="entry.project !== null">
                  <span
                    class="c-calendar__tooltip-project-number"
                  >{{ entry.project.project_number }}</span>
                  <v-week-day-content-day-graphic :numberOfDays="calcNumberOfDays(entry)"></v-week-day-content-day-graphic>
                  <br />
                  <small>
                    {{ entry.project.customer.company_name }} / {{ entry.project.profile.firstname }} {{ entry.project.profile.lastname }}
                    <strong class="u-color--primary" v-if="entry.is_date_fixed">{{ $t('weeks.project.is_date_fixed') }}</strong>
                  </small>
                </template>
                <template v-if="entry.tour !== null">
                  <span class="c-calendar__tooltip-project-number">{{ entry.tour.tour_number }}</span>
                  <v-week-day-content-day-graphic :numberOfDays="calcNumberOfDays(entry)"></v-week-day-content-day-graphic>
                </template>
              </section>
            </div>
          </div>
        </div>
        <div class="grid-x grid-margin-x">
          <div class="cell small-12">
            <p class="u-no-margin">
              <strong>{{ $t('form.comments.comment') }}</strong>
            </p>
          </div>
          <div class="cell small-10">
            <input
              name="comment"
              v-model="editedtext"
              type="text"
              class="c-calendar__tooltip-comment"
            />
          </div>
          <div class="cell small-2">
            <button
              class="c-calendar__tooltip-save-button button button--action button--action--save"
              @click.prevent="saveWeekDay"
            ></button>
          </div>
        </div>
      </section>
    </tippy>
  </div>
</template>

<script>
import WeekDayContentDayGraphic from "./weekDayContentDayGraphic";

export default {
  name: "WeekDayContent",
  components: {
    vWeekDayContentDayGraphic: WeekDayContentDayGraphic
  },
  props: {
    is_holiday: {
      type: Boolean,
      default: false
    },
    comment: {
      type: String,
      default: ""
    },
    date: {
      type: Date,
      default: null
    },
    kolonne_number: {
      type: String,
      default: ""
    },
    index: {
      type: Number,
      default: null
    },
    count: {
      type: Number,
      default: null
    },
    daily_entries: {
      type: Array,
      default: () => []
    },
    first_entry: {
      type: Object,
      default: () => []
    }
  },

  data: function() {
    return {
      editedtext: this.comment || ""
    };
  },

  computed: {
    isFixed: function() {
      return this.daily_entries.some(entry => entry.is_date_fixed);
    }
  },

  methods: {
    calcNumberOfDays: function(entry) {
      return (
        this.$moment(entry.enddate).diff(
          this.$moment(entry.startdate),
          "days"
        ) + 1
      );
    },
    saveWeekDay: function() {
      this.$emit("saveWeekDay", this.editedtext);
    }
  }
};
</script>